module.exports = __webpack_public_path__ + "assets/img/4213-ac.svg";